import { Alert, Button, Divider, Form, Input } from 'antd';
import { Cache } from 'aws-amplify';
import get from 'lodash/get';
import { useState } from 'react';
import GoogleButton from 'react-google-button';
import {
	auth,
	getWarmGoogleAuth,
	googleSignInConfig,
	graphql,
	lowerCase,
	startHostedUiSignIn,
} from 'src/_shared/services/utils.js';
import { SubmitBtnContainer as SubmitButtonContainer } from '../fogotten-password-modal/forgottenPasswordModalStyles.js';

export const OrganizationModalPageOne = ({ theme, error }) => {
	const [form] = Form.useForm();
	const [state, setState] = useState({
		cognitoError: false,
		errorMessage: '',
	});

	const handleSubmit = async (values) => {
		localStorage.setItem('authType', 'saml');

		try {
			const { origin } = window.location;

			const organizationcode = values?.organizationcode || '';
			const saml = await graphql({
				input: { id: lowerCase(organizationcode.trim()) },
				query: 'getSAMLAuth',
			});

			if (
				lowerCase(get(values, 'organizationcode', '')).trim() ===
				get(saml, 'id')
			) {
				Cache.setItem(
					'federatedOrgCode',
					lowerCase(get(values, 'organizationcode', '')).trim()
				);
				Cache.setItem('federatedClientId', get(saml, 'clientId'));
				Cache.setItem('federatedDomain', get(saml, 'domain'));
				Cache.setItem('federatedRegion', get(saml, 'region', 'us-east-2'));
				startHostedUiSignIn(
					`https://${get(saml, 'domain')}.auth.${get(
						saml,
						'region',
						'us-east-2'
					)}.amazoncognito.com/oauth2/authorize?identity_provider=${get(
						saml,
						'provider'
					)}&redirect_uri=${origin}/saml-auth/login&response_type=code&client_id=${get(
						saml,
						'clientId'
					)}`
				);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleSubmitGoogle = async () => {
		localStorage.setItem('authType', 'saml');
		const saml = getWarmGoogleAuth() || (await googleSignInConfig());
		const clientId = get(saml, 'clientId');
		Cache.setItem('federatedOrgCode', 'google');
		Cache.setItem('federatedClientId', clientId);
		Cache.setItem('federatedDomain', get(saml, 'domain'));
		Cache.setItem('federatedRegion', get(saml, 'region', 'us-east-2'));
		const { origin } = window.location;
		const url = `https://erinapp.auth.us-east-2.amazoncognito.com/oauth2/authorize?identity_provider=Google&redirect_uri=${origin}/saml-auth/login&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&client_id=${clientId}`;
		startHostedUiSignIn(url);
	};

	const renderError = (error, message) => {
		return error ? <Alert type="error" message={message} /> : null;
	};

	const { cognitoError, errorMessage } = state;

	return (
		<div>
			<Form form={form} onFinish={handleSubmit}>
				<Form.Item
					name="organizationcode"
					rules={[
						{
							required: true,
							message: 'Code Required',
						},
						{
							type: 'string',
						},
						{
							validator: async (_, value) => {
								if (!value) return Promise.resolve();

								const organizationcode = value || '';
								const saml = await graphql({
									input: { id: lowerCase(organizationcode.trim()) },
									query: 'getSAMLAuth',
								});

								if (!saml) {
									return Promise.reject(new Error('Invalid Code'));
								}

								return Promise.resolve();
							},
						},
					]}
				>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<div
							className="custom-form-group"
							style={{ margin: '0 8px 0 0', flex: '1' }}
						>
							<Input className="custom-input" placeholder="enter code" />
						</div>
						<Button type="primary" size="large" htmlType="submit">
							Continue
						</Button>
					</div>
				</Form.Item>
				{cognitoError && <Alert type="error" message={errorMessage} />}
				<Form.Item className={SubmitButtonContainer}>
					<Divider plain>or</Divider>
					<div
						style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
					>
						<GoogleButton
							style={{ marginBottom: 16, marginTop: 22 }}
							onClick={async () => handleSubmitGoogle()}
						/>
					</div>
				</Form.Item>
				{renderError(error, error)}
			</Form>
		</div>
	);
};

export default OrganizationModalPageOne;
